import { Component, OnInit, ViewEncapsulation, Input, ɵConsole } from '@angular/core';
import {FormGroup, FormBuilder, Validators} from '@angular/forms';
import {NgbModal,NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import { Observable, Subject, ReplaySubject } from 'rxjs';
import { finalize, takeUntil, tap } from 'rxjs/operators';

import { FormControl } from '@angular/forms';
import { CustomService } from '../../contact-setting/services/custom.service';
import { AttributeType } from '../../contact-setting/models/attribute-type.model';
import { LooupValues } from '../../contact-setting/models/looup-values.model';
import { ContactListService } from '../../contact-setting/services/contact-list.service';
import { Contact } from '../../contact-setting/models/contact.model';
import { DateAttributes } from '../../contact-setting/models/date-attributes.model';
import { StdLookupAttribute } from '../../contact-setting/models/std-lookup-attribute.model';
import {MatChipInputEvent} from '@angular/material/chips';
import {ENTER, COMMA} from '@angular/cdk/keycodes';


@Component({
  selector: 'kt-add-custom-attribute',
  templateUrl: './add-custom-attribute.component.html',
  styleUrls: ['./add-custom-attribute.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class AddCustomAttributeComponent implements OnInit {

  visible = true;
  selectable = true;
  removable = true;
  addOnBlur = true;
  readonly separatorKeysCodes: number[] = [ENTER, COMMA];
  lookupVal: LooupValues[] = [];

  private unsubscribe: Subject<any>;
  private returnUrl: any;
  loading = false;
  attributeContactType: string;
  mandatoryContact:boolean;
  mandatoryContactFlag:number;
  errorMes:String="";
 
  stdLookupList: StdLookupAttribute[];

  attributeType:AttributeType;
  resultSet:any;
  resultSetForContact:any;
  resultSetStandard:any;

  displayDateValueDiv: boolean;
  displayMultiSelectDiv: boolean;
  displaySingleSelectDiv:boolean;
  allContactTypeList: Contact[];
  dateAttributes: DateAttributes;
  lookUpValues: LooupValues[];
  lookup:LooupValues;
  standardTypeValue: StdLookupAttribute;
  contactTypes: Contact[];
  contactTyp: Contact;
  contactTypesIds: string;
  customAttributeId: number;
  customAttributeName: string;
  disabled:boolean;
  duplicate:boolean;
  flag_Value:boolean;
  moduleType:string | number;

  selectedProject = JSON.parse(localStorage.getItem('selectedProject'));


  /** list of banks filtered by search keyword */
  public attributeTypelist: ReplaySubject<AttributeType[]> = new ReplaySubject<AttributeType[]>(1);

  public standardTypelist: ReplaySubject<StdLookupAttribute[]> = new ReplaySubject<StdLookupAttribute[]>(1);
  
  public allContactTypList: ReplaySubject<Contact[]> = new ReplaySubject<Contact[]>(1);

  resultSetOfattributeTypelist:AttributeType[];
  resultSetOfstandardTypelist:StdLookupAttribute[];
  resultSetOfallContactTypList:Contact[];

  /** control for the MatSelect filter keyword */
  public attributeFilterType: FormControl = new FormControl();
  public standardFilterType: FormControl = new FormControl();
  public contactFilterType: FormControl = new FormControl();


  public addCustomAttributeForm: FormGroup;

   /** Subject that emits when the component has been destroyed. */
  protected _onDestroy = new Subject<void>();

  constructor(private modalService: NgbModal,
    private fb: FormBuilder,
    public activeModal: NgbActiveModal,
    public customService: CustomService,
    public contactService: ContactListService) {
       this.unsubscribe = new Subject();
   }

  ngOnInit(): void {
    this.initaddCustomAttributeForm();
    this.getAttributeType(this.moduleType);
    this.getAllContactTypeList();
    this.displayDateValueDiv=false;
    this.displayMultiSelectDiv=false;
    this.displaySingleSelectDiv=false;
    this.dateAttributes=new DateAttributes();
    this.dateAttributes.stdLookupAttribute= new StdLookupAttribute();
    this.lookUpValues= new Array<LooupValues>();
    this.contactTypes= new Array<Contact>();
    this.contactTypesIds='';
    this.disabled=false;
    this.duplicate=false;
    this.flag_Value=false;

     // listen for search field value changes -- ATTRIBUTE TYPE FILTER
     this.attributeFilterType.valueChanges
     .pipe(takeUntil(this._onDestroy))
     .subscribe(() => {
      // get the search keyword
       const search = this.attributeFilterType.value;
       this.filterAttributeType(search);
     });

     // listen for search field value changes
     this.standardFilterType.valueChanges
     .pipe(takeUntil(this._onDestroy))
     .subscribe(() => {
      // get the search keyword
       const search = this.standardFilterType.value;
       this.filterStandardType(search);
     });

     // listen for search field value changes
     this.contactFilterType.valueChanges
     .pipe(takeUntil(this._onDestroy))
     .subscribe(() => {
      // get the search keyword
       const search = this.contactFilterType.value;
       this.filterContactType(search);
     });


  }
  getAttributeType(data){
    this.customService.getAtrributeType(data).subscribe(
		(result)=>{
        this.attributeTypelist.next(result);
        this.resultSetOfattributeTypelist=result;
		},
		error => {
			console.log(error)
    })

  }
  
  protected filterAttributeType(search) {
    if (!search) {
     this.attributeTypelist.next(this.resultSetOfattributeTypelist);
      return;
    } else {
      search = search.toLowerCase();
    }
    // filter the banks
    this.attributeTypelist.next(
      this.resultSetOfattributeTypelist.filter(res => res.typeName.toLowerCase().indexOf(search) > -1)
    );
 }
 
  getStandardLookUpList(){
    var attributeId=this.attributeType.id;
    var attributeName=this.attributeType.typeName;
    this.customService.getstdLookUpList(attributeId,attributeName).subscribe(

		(result)=>{
        this.standardTypelist.next(result);
        this.resultSetOfstandardTypelist=result;
		},
		error => {
			console.log(error)
    })
  }

  protected filterStandardType(search) {
     if (!search) {
      this.standardTypelist.next(this.resultSetOfstandardTypelist);
       return;
     } else {
       search = search.toLowerCase();
     }
     // filter the banks
     this.standardTypelist.next(
       this.resultSetOfstandardTypelist.filter(res => res.value.toLowerCase().indexOf(search) > -1)
     );
  }


  getAllContactTypeList(){
    this.contactService.getContact(this.selectedProject).subscribe(
		(result)=>{

        this.allContactTypList.next(result['responseData']);
        this.resultSetOfallContactTypList=result['responseData'];
        this.allContactTypeList=result['responseData'];
		},

		error => {
			console.log(error)
    })
  }


  protected filterContactType(search) {
     if (!search) {
      this.allContactTypList.next(this.resultSetOfallContactTypList);
       return;
     } else {
       search = search.toLowerCase();
     }
     // filter the banks
     this.allContactTypList.next(
       this.resultSetOfallContactTypList.filter(res => res.contactTypeName.toLowerCase().indexOf(search) > -1)
     );
  }

  initaddCustomAttributeForm(){
    this.addCustomAttributeForm = this.fb.group({
      attributeName: ['', Validators.compose([Validators.required,Validators.maxLength(50) ])],
      attributeType: ['', Validators.compose([ Validators.required])],
      dateValueType: [''],
      attributeMultiSelectName:[''],
      attributeSingleName:[],
      attributeContactType:[],
      standardTypeValue:[],
      lookup:[],
      futureDateValue:[],
      previousDateValue:[],
      mandatoryCheck:[]
     });
  }

  Save(){
    this.disabled=true;
    this.errorMes="";
    const controls = this.addCustomAttributeForm.controls;
      if (this.addCustomAttributeForm.invalid) {
        Object.keys(controls).forEach(controlName =>
          controls[controlName].markAsTouched()
        );
        this.disabled=false;
        return;
      }
      const addAttributeData = {
        attributeName: controls.attributeName.value,
        dateValueType: controls.dateValueType.value,
        attributeContactType: controls.attributeContactType.value,
        singleValues: controls.attributeSingleName.value,
        ValuesMutli: controls.attributeMultiSelectName.value,
        futureDateValue: controls.futureDateValue.value,
        previousDateValue: controls.previousDateValue.value
      };

      if(this.mandatoryContact == true){
        this.mandatoryContactFlag=1;
      }else{
        this.mandatoryContactFlag=0;
      }
      if(this.attributeType.id ==1){
        //this.lookup = new LooupValues();
        //this.lookup.isActive=1;
        //this.lookup.lookupValue=addAttributeData.singleValues;
        //this.lookUpValues.push(this.lookup);

      }else if(this.attributeType.id ==2){

     // console.log('fruits------------'+this.lookupVal);
      //for(let fr of this.lookupVal){
        //console.log('f--'+fr.lookupValue);
        //console.log('active----'+fr.isActive);
      //}
      }else{
        this.lookupVal=[];
      }
      if(this.attributeType.id ==3){
        if(addAttributeData.dateValueType == 'Standard'){
            this.dateAttributes.stdLookupAttribute.id=this.standardTypeValue.id;
            this.dateAttributes.stdLookupAttribute.value=this.standardTypeValue.value;
            this.dateAttributes.previousDateAllowed=null;
            this.dateAttributes.futureDateAllowed=null;
        }else if(addAttributeData.dateValueType =='Custom'){
            this.dateAttributes.previousDateAllowed=Number(addAttributeData.previousDateValue);
            this.dateAttributes.futureDateAllowed=Number(addAttributeData.futureDateValue);
            this.dateAttributes.stdLookupAttribute=null;
        }else{
            this.dateAttributes=null;
        }
      }

      if(!(this.contactTypesIds=='')){
      var array = this.contactTypesIds.split(',');
      for(var i=0;i<array.length;i++){
         var contactId= array[i];
          for(let contact of this.allContactTypeList){
            if(contact.id == Number(contactId)){
               this.contactTyp = new Contact();
               this.contactTyp.id=Number(contactId);
               this.contactTyp.contactTypeName=contact.contactTypeName;
               this.contactTypes.push(this.contactTyp);
            }
         }
      } 
      }

      this.customService
      .addCustomAttribute(addAttributeData.attributeName, this.attributeType,this.mandatoryContactFlag,
        this.lookupVal,this.dateAttributes, this.selectedProject)
        .pipe(
          tap(CustomAttibute => {
           console.log(CustomAttibute);
              this.customAttributeId= CustomAttibute['responseData'].attributeId;
              this.customAttributeName= addAttributeData.attributeName;
              if(!(this.contactTypesIds=='')){
              this.customService
                  .addCustomAttributeToContact(this.customAttributeId,this.customAttributeName,this.contactTypes, this.selectedProject)
                      .pipe(
                      tap(Contact => {
                        this.loading = false;
                        this.activeModal.close();
                        this.addCustomAttributeForm.reset();
                        //console.log(Contact);
                      }),
                       takeUntil(this.unsubscribe),
                       finalize(() => {
                        
                 })
                )
                .subscribe(
                   data => console.log("sucesssfully called CONTACT CUSTOM  API"),
                   error => {
                    this.errorMes=error.error.responseData;
                    this.disabled=false;
                  }
                );
              }else{
                this.loading = false;
                        this.activeModal.close();
                        this.addCustomAttributeForm.reset();
              }  
          }),
          takeUntil(this.unsubscribe),
          finalize(() => {
           // this.loading = false;
           // this.activeModal.close();
           // this.addCustomAttributeForm.reset();
          })
        )
        .subscribe(
          data => {console.log("sucesssfullycalled Custom Attribute API");
          this.activeModal.close();
          },
          error => {
            this.errorMes=error.error.responseData;
            this.disabled=false;
          }
          
        );  
      
      
  }

  get addCustomData(){
    return this.addCustomAttributeForm.controls;
  }

  changeStd(data){
   this.standardTypeValue=data;
  }

  changeMulti(data){
    this.contactTypesIds=data.toString();
  }

  change(data){
    this.attributeType=data;
    if(this.attributeType.id ==3){
      this.displayDateValueDiv=true;
      this.getStandardLookUpList();
      this.addCustomAttributeForm.controls.dateValueType.setValidators([Validators.required]);
      this.addCustomAttributeForm.controls.dateValueType.updateValueAndValidity();
    }else{
      this.displayDateValueDiv=false;
      this.addCustomAttributeForm.controls.dateValueType.clearValidators();
      this.addCustomAttributeForm.controls.dateValueType.updateValueAndValidity();
      this.resetDateValue();
    }

    if(this.attributeType.id ==2){
      this.displayMultiSelectDiv=true;
      this.addCustomAttributeForm.controls.attributeMultiSelectName.setValidators([Validators.required]);
      this.addCustomAttributeForm.controls.attributeMultiSelectName.updateValueAndValidity();
    }else{
      this.displayMultiSelectDiv=false;
      this.addCustomAttributeForm.controls.attributeMultiSelectName.clearValidators();
      this.addCustomAttributeForm.controls.attributeMultiSelectName.updateValueAndValidity();
    }

    if(this.attributeType.id ==1){
      this.displaySingleSelectDiv=true;
      this.addCustomAttributeForm.controls.attributeSingleName.setValidators([Validators.required]);
      this.addCustomAttributeForm.controls.attributeSingleName.updateValueAndValidity();
    }else{
      this.displaySingleSelectDiv=false;
      this.addCustomAttributeForm.controls.attributeSingleName.clearValidators();
      this.addCustomAttributeForm.controls.attributeSingleName.updateValueAndValidity();
    }

  }

  isDisplayStandard(): boolean{
    if(this.addCustomAttributeForm.controls.dateValueType.value =='Standard'){
      this.addCustomAttributeForm.controls.standardTypeValue.setValidators([Validators.required]);
      this.addCustomAttributeForm.controls.standardTypeValue.updateValueAndValidity();
      return true;
    }else{
      this.addCustomAttributeForm.controls.standardTypeValue.clearValidators();
      this.addCustomAttributeForm.controls.standardTypeValue.updateValueAndValidity();
      return false;
    }
  }

  isDisplayCustom(): boolean{
    if(this.addCustomAttributeForm.controls.dateValueType.value =='Custom'){
      return true;
    }else{
      return false;
    }
  }

  showOptions(val) {
    this.mandatoryContact=val;
  }

  resetDateValue(){
    this.addCustomAttributeForm.controls['dateValueType'].reset();
  }

  Close(){
    this.activeModal.close();
    this.addCustomAttributeForm.reset();
  }
  isControlHasError(controlName: string, validationType: string): boolean {
    const control = this.addCustomAttributeForm.controls[controlName];
      if (!control) {
        return false;
      }
      const result = control.hasError(validationType) && (control.dirty || control.touched);
      return result;
  }

  ngOnDestroy() {
    this._onDestroy.next();
    this._onDestroy.complete();
  }

  add(event: MatChipInputEvent): void {
    const input = event.input;
    const value = event.value;
    this.duplicate=false;
   
    if ((value || '').trim()) {
      for(let fr of this.lookupVal){
        var name= fr.lookupValue;
        if(value.trim()==name){
          this.duplicate=true;
        }
      }
      if(this.duplicate==false){
      this.lookupVal.push({lookupValue: value.trim(),
      isActive: 1, stageId:null});
      }
    }

    // Reset the input value
    if (input) {
      input.value = '';
    }
  }

  remove(lookup: LooupValues): void {
    const index = this.lookupVal.indexOf(lookup);

    if (index >= 0) {
      this.lookupVal.splice(index, 1);
    }
  }

  isDisabled() : boolean {
    return this.disabled;
   }

   resetAll(){
    this.addCustomAttributeForm.controls['mandatoryCheck'].reset();
    this.addCustomAttributeForm.reset();
    this.lookupVal=[];
    this.addCustomAttributeForm.controls['attributeMultiSelectName'].reset();
    this.addCustomAttributeForm.controls['attributeSingleName'].reset();
    this.flag_Value=false;
    this.disabled=false;
    this.displayDateValueDiv=false;
    this.addCustomAttributeForm.controls.dateValueType.clearValidators();
    this.addCustomAttributeForm.controls.dateValueType.updateValueAndValidity();
    this.resetDateValue();
    this.displayMultiSelectDiv=false;
    this.addCustomAttributeForm.controls.attributeMultiSelectName.clearValidators();
    this.addCustomAttributeForm.controls.attributeMultiSelectName.updateValueAndValidity();
    this.displaySingleSelectDiv=false;
    this.addCustomAttributeForm.controls.attributeSingleName.clearValidators();
    this.addCustomAttributeForm.controls.attributeSingleName.updateValueAndValidity();
    this.isDisplayStandard();
    this.isDisplayCustom();
   }
}
